module.exports = __webpack_public_path__ + "static/media/Stock-Footage-of-Shopping-for-Women-s-Clothing_VP8.b41258c9.webm";